import React, { useState } from "react";
import { T } from "services/lang/LanguageService";

import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Message } from 'primereact/message';
import { IFormData, IRegisterFormProps } from "../../interfaces";
import '../../styles.css';

const RegisterForm = (props: IRegisterFormProps) => {
    const [invalidValues, setInvalidValues] = useState<Array<string>>([]);

    const defaultValues = {
        name: '',
        surname: '',
        email: '',
        reemail: '',
        phone: '',
        company: ''
    }

    const [formData, setFormData] = useState<IFormData>({
        timeSlot: new Date(props.selectedDateTime).getTime(),
        timeZoneOffset: new Date(props.selectedDateTime).getTimezoneOffset(),
        timezoneId: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
        name: defaultValues.name,
        surname: defaultValues.surname,
        email: defaultValues.email,
        reemail: defaultValues.reemail,
        company: defaultValues.company,
        phone: defaultValues.phone,
    });

    const convertDateToString = (d: Date): string => {
        const datestring = `${d.getFullYear()  }-${  (`0${  d.getMonth() + 1}`).slice(-2)  }-${  (`0${  d.getDate()}`).slice(-2)
             } ${  (`0${  d.getHours()}`).slice(-2)  }:${  (`0${  d.getMinutes()}`).slice(-2)}`;
        return datestring;
    }

    const handleScheduleEvent = () => {
        let dataIsValid = true;
        const tempInvalidInputs = [];

        const optionalFields = ['company', 'timezoneId'];// TODO show error if browser does not support 'timezoneId

        for (const [key, value] of Object.entries(formData)) {
            if (!optionalFields.includes(key)) {
                if (!value) {
                    tempInvalidInputs.push(key);
                    dataIsValid = false;
                }
            }
        }
        if (formData.email !== formData.reemail) {
            dataIsValid = false;
        }
        setInvalidValues(tempInvalidInputs);

        if (dataIsValid) {
            props.onScheduleEvent(formData);
        } else {
            easasAlert({ summary: T("alert.error"), detail: T("error.fields-must-be-filled"), severity: "error" });
        }
    }

    const validateStringInput = (value: string, handler: CallableFunction, field: string) => {
        if (value) {
            handler(value, field);
        } else {
            handler('', field);
        }
    }

    const handleFieldChange = (value: string, field: string) => {
        const tempData = { ...formData };
        // @ts-ignore
        tempData[`${field}`] = value;
        setFormData(tempData);
    }

    const submitBtnText = () => {
        return props.scheduling ? T("message.please-wait") : T("action.submit-booking");
    }

    const chunkStyle = {
        margin: '10px',
        // width: '100%',
    }

    const inputStyle = {
        width: '100%',
    }

    const inputInvalidStyle = {
        width: '60%',
    }

    return (
        <div className="flex justify-content-center">
            <div style={{ maxWidth: '600px', height: 'auto', margin: '0 auto', padding: '10px', position: 'relative' }}>
                <div className="formgroup-inline mb-2" style={chunkStyle}>
                    {T("label.event-time")}: <strong>{convertDateToString(new Date(props.selectedDateTime))}</strong>
                </div>

                <div className="formgroup-inline mb-2" style={chunkStyle}>
                    <label htmlFor="name" className="p-sr-only">{T("word.name")}</label>
                    <InputText id="name" placeholder={`${T("word.name")}*`} onChange={(e) => validateStringInput(e.target.value, handleFieldChange, 'name')} style={invalidValues.includes('name') ? inputInvalidStyle : inputStyle} className={invalidValues.includes('name') ? "p-invalid" : ""} />
                    {
                        invalidValues.includes('name') && <Message severity="error" text={T("message.name-is-required")} />
                    }
                </div>

                <div className="formgroup-inline mb-2" style={chunkStyle}>
                    <label htmlFor="surname" className="p-sr-only">{T("word.surname")}</label>
                    <InputText id="surname" placeholder={`${T("word.surname")}*`} onChange={(e) => validateStringInput(e.target.value, handleFieldChange, 'surname')} style={invalidValues.includes('surname') ? inputInvalidStyle : inputStyle} className={invalidValues.includes('surname') ? "p-invalid" : ""} />
                    {
                        invalidValues.includes('surname') && <Message severity="error" text={T("message.surname-is-required")} />
                    }
                </div>

                <div className="formgroup-inline" style={chunkStyle}>
                    <label htmlFor="email" className="p-sr-only">{T("word.email")}</label>
                    <InputText id="email" placeholder={`${T("word.email")}*`} onChange={(e) => validateStringInput(e.target.value, handleFieldChange, 'email')} style={invalidValues.includes('email') ? inputInvalidStyle : inputStyle} className={invalidValues.includes('email') ? "p-invalid" : ""} />
                    {
                        invalidValues.includes('email') && <Message severity="error" text={T("message.email-is-required")} />
                    }
                </div>
                <div className="formgroup-inline" style={chunkStyle}>
                    <label htmlFor="reemail" className="p-sr-only">{T("action.re-enter-email")}</label>
                    <InputText id="reemail" placeholder={T("action.re-enter-email")} onChange={(e) => validateStringInput(e.target.value, handleFieldChange, 'reemail')} style={invalidValues.includes('reemail') || formData.email !== formData.reemail ? inputInvalidStyle : inputStyle} className={invalidValues.includes('reemail') || formData.email !== formData.reemail ? "p-invalid" : ""} />
                    {
                        invalidValues.includes('reemail') ? (
                            <Message severity="error" text={T("message.email-is-required")} />
                        ) : (
                            formData.email !== formData.reemail &&
                            <Message severity="error" text={T("error.emails-must-match")} />
                        )
                    }
                </div>

                <div className="formgroup-inline" style={chunkStyle}>
                    <label htmlFor="company" className="p-sr-only">{T("word.company")}</label>
                    <InputText id="company" placeholder="Company" onChange={(e) => handleFieldChange(e.target.value, 'company')} style={inputStyle} />
                </div>

                <div className="formgroup-inline" style={chunkStyle}>
                    <label htmlFor="phone" className="p-sr-only">{`${T("word.phone")}*`}</label>
                    <InputText id="phone" placeholder={`${T("word.phone")}*`} onChange={(e) => validateStringInput(e.target.value, handleFieldChange, 'phone')} style={invalidValues.includes('phone') ? inputInvalidStyle : inputStyle} className={invalidValues.includes('phone') ? "p-invalid" : ""} />
                    {
                        invalidValues.includes('phone') && <Message severity="error" text={T("message.phone-is-required")} />
                    }
                </div>

                <div style={chunkStyle}>
                    <div className={props.isMobile ? '' : 'p-d-flex'} style={{ padding: '10px' }}>
                        <div>
                            <Button label={T("word.cancel")} onClick={() => { props.handleConfimCancel() }} className='p-button-danger p-button-text' />
                        </div>
                        <div style={{ marginLeft: 'auto' }}>
                            <Button label={submitBtnText()} disabled={props.scheduling} onClick={() => handleScheduleEvent()} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RegisterForm;